import { HAS_WINDOW } from '@eventbrite/feature-detection';

export const getIsAppRebrandActiveFromURL = () => {
    const appRebrandParam = HAS_WINDOW
        ? new URLSearchParams(window.location.search).get(
              'is_app_rebrand_active',
          )
        : null;

    return appRebrandParam === 'true';
};
